
import { Options, Vue } from 'vue-class-component';
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/vue'
@Options({
  components: {
    Popover, PopoverButton, PopoverGroup, PopoverPanel
  }
})
export default class HelloWorld extends Vue {
  msg!: string
}
